export default __webpack_public_path__ + "static/media/reset.42919703.svg";